import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { Customer } from 'src/features/customers/utils/types';
import CustomerFormModal from 'src/features/customers/components/forms/CustomerFormModal';
import { customersMessages } from 'src/features/customers/utils/messages';
import { LIST_CUSTOMERS_RESOURCE } from 'src/features/customers/api/useListCustomers';
import { useCreateCustomer } from 'src/features/customers/api/useCreateCustomer';

interface CreateCustomerFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedCustomer?: Customer;
    children?: React.ReactNode;
}

function CreateCustomerFormModal<TData>({ className, semantics }: CreateCustomerFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateCustomer({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_CUSTOMERS_RESOURCE] });
            toast({
                title: formatMessage(customersMessages.createCustomerSuccess),
                description: formatMessage(customersMessages.createCustomerSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <CustomerFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(customersMessages.addCustomerSubtitle)}
        />
    );
}

export default CreateCustomerFormModal;
